import { viewSchemas } from "@redotech/redo-views-common/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const generateInventoryLevelReport = {
  name: "generateInventoryLevelReport" as const,
  input: z.object({
    view: viewSchemas["inventory-levels"],
    locationIds: z.array(z.string()).optional(),
    productIds: z.array(z.string()).optional(),
    sendToEmail: z.string().email().optional(),
    exportFormat: createEnum(["summary", "detailed"]).optional(),
    fileFormat: createEnum(["csv", "pdf"]).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string(),
    reportData: z
      .array(
        z.object({
          productName: z.string(),
          sku: z.string(),
          status: z.string(),
          price: z.number().nullable(),
          cost: z.number().nullable(),
          location: z.string(),
          available: z.number(),
          buildable: z.number(),
          totalAvailableWithBuildable: z.number().default(0),
          committed: z.number(),
          reserved: z.number(),
          onHand: z.number(),
          totalPrice: z.number().nullable(),
          totalCost: z.number().nullable(),
          isTotal: z.boolean(),
        }),
      )
      .optional(),
    emailSent: z.boolean().optional(),
    pdfData: z.string().optional(),
  }),
};
